// Re-export the shared ProductSearch component for seller
import ProductSearch from "../Admin/ProductSearch";

export default function SellerProductSearch() {
    return <ProductSearch role="seller" />;
}

